import { escapeRegExp } from 'lodash';

export function searchParams (columns, search) {
  if (search == null || search === '') return null;
  let $or = columns.reduce((acc, v) => {
    if (v.search) {
      if (typeof v.search === 'function') {
        acc.push(v.search(search, v));
      } else {
        acc.push({[v.sortField || v.name]: {$regex: escapeRegExp(search), $options: 'i'}});
      }
    }
    return acc;
  }, []);
  return $or.length ? {$or} : null;
}



// WEBPACK FOOTER //
// ./src/services/schemaUtils.js